export default __webpack_public_path__ + "static/media/elevate-pyl-4.87992f0a.png";